import {
  AddCollaboratorsHistorySkillLanguages,
  GetCollaboratorsHistorySkillLanguagesResponse,
  UpdateCollaboratorsHistorySkillLanguages,
} from "../../../types/api/collaborators.type";
import httpClient from "../../client/HttpClient";

const CollaboratorsHistoryLanguagesService = {
  async get(
    collaboratorId: number,
  ): Promise<GetCollaboratorsHistorySkillLanguagesResponse> {
    const response =
      await httpClient.get<GetCollaboratorsHistorySkillLanguagesResponse>(
        `v1/collaborators/${collaboratorId}/history/languages`,
      );
    return response;
  },
  async addLanguage(
    collaboratorId: number,
    body: AddCollaboratorsHistorySkillLanguages,
  ): Promise<void> {
    await httpClient.post(
      `v1/collaborators/${collaboratorId}/history/languages`,
      body,
    );
  },
  async delete(collaboratorId: number, languageId: number): Promise<void> {
    await httpClient.delete(
      `v1/collaborators/${collaboratorId}/history/languages/${languageId}`,
    );
  },
  async update(
    collaboratorId: number,
    languageId: number,
    body: UpdateCollaboratorsHistorySkillLanguages,
  ): Promise<void> {
    await httpClient.put(
      `v1/collaborators/${collaboratorId}/history/languages/${languageId}`,
      body,
    );
  },
};

export default CollaboratorsHistoryLanguagesService;
